if (!customElements.get('quick-shop')) {
  class Quickshop extends HTMLElement {
    constructor() {
      super()
      const self = this

      this.parentCardsWrapper = this.closest('[data-product-cards-wrapper]')
      this.parentCard = this.closest('[data-product-card]')
      this.quickShopElements = this.parentCardsWrapper.querySelectorAll('quick-shop')

      // Bind popup toggle events
      this.parentCard.querySelectorAll('[data-quickshop-toggle]').forEach((button) => {
        button.classList.add('product-card__quickshop-trigger--active')
        button.addEventListener('click', this.openPopup.bind(this))
      })

      // Bind product cards event
      this.parentCard.addEventListener('mouseenter', this.handleCloseAllPopups.bind(this))
      this.parentCard.addEventListener('touchstart', this.handleCloseAllPopups.bind(this))
    }

    /**
     * Opens the options popup
     */
    openPopup() {
      // Close all other quickshop if they exist
      this.closeAllPopups()

      const popup = this.querySelector('[data-quickshop-popup]')
      const popupIsOpenClass = 'quickshop__popup--is-open'

      popup.classList.add(popupIsOpenClass)
    }

    /**
     * Closes the options popup
     */
    closePopup() {
      const popup = this.querySelector('[data-quickshop-popup]')
      const popupIsOpenClass = 'quickshop__popup--is-open'

      popup.classList.remove(popupIsOpenClass)
    }

    /**
     * Handle close all popups
     */
    handleCloseAllPopups() {
      if (this.parentCard.querySelector('.quickshop__popup').classList.contains('quickshop__popup--is-open')) {
        return
      }
      this.closeAllPopups()
    }

    /**
     * Closes all options popups
     */
    closeAllPopups() {
      if (this.quickShopElements.length > 0) {
        this.quickShopElements.forEach((quickShopElement) => {
          quickShopElement.closePopup()
        })
      }
    }
  }

  window.Quickshop = Quickshop
  customElements.define('quick-shop', Quickshop)
}
